import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';

import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
  styleUrls: ['./forgot-password-dialog.component.css']
})
export class ForgotPasswordDialogComponent {

  passwordResetMailSent: boolean = false;
  error: string;

  constructor(
    public dialogRef: MdDialogRef<ForgotPasswordDialogComponent>,
    private auth:     AuthService
  ) { }

  forgotPassword(event, email: string): void {
    event.preventDefault();
    this.auth.resetPassword(email)
      .then(()      => this.passwordResetMailSent = true)
      .catch(error  => this.error = error.message);
  }

}



// WEBPACK FOOTER //
// ./src/app/login/forgot-password-dialog/forgot-password-dialog.component.ts